import * as React from 'react';
import Draggable from 'react-draggable';
import { JQueryUiButton } from '../../Common/JqueryUiButton';

export interface FillPopupProps {
    /**
     * Whether the popup should be displayed
     */
    show: boolean;
    /**
     * The function to call when the popup closes
     */
    onClose: (fillAll: boolean, value?: string) => void;
    /**
     * The initial x position of the popup
     */
    x: number;
    /**
     * The initial y position of the popup
     */
    y: number;
}

export interface FillPopupState {
    /**
     * The value of the popup's input
     */
    value: string;
}

/**
 * The Fill Popup component
 */
export class FillPopup extends React.Component<FillPopupProps, FillPopupState> {
    constructor(props: FillPopupProps) {
        super(props);
        this.state = {
            value: ''
        };
    }

    /**
     * Clear the value state when the props change
     * @param _ New props
     */
    componentWillReceiveProps(_: FillPopupProps) {
        this.setState({ value: '' });
    }

    render() {
        /**
         * Do not render anything when this is false
         */
        if (!this.props.show) {
            return null;
        }

        const dialogStyle: React.CSSProperties = {
            backgroundColor: '#fff',
            borderRadius: 5,
            maxWidth: 360,
            height: 'auto',
            padding: 0,
            border: '1px solid #000'
        };

        const headerStyles: React.CSSProperties = {
            border: '1px solid black',
            fontWeight: 700,
            padding: '4.69px 11.733px',
            margin: 1,
            borderRadius: 4,
            minHeight: 16,
            cursor: 'move'
        };

        const backdrop: React.CSSProperties = {
            position: 'fixed',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: 'rgba(170, 170, 170, 0.3)',
            zIndex: 1001
        };

        return (
            <div style={backdrop}>
                <Draggable axis="both" handle=".handle" defaultPosition={{x: this.props.x, y: this.props.y}}>
                    <div style={dialogStyle}>
                        <div
                            style={headerStyles}
                            className="ui-corner-all copia_color1_b handle"
                        >
                            <span
                                className="ui-dialog-title"
                                style={{ color: '#fff', fontSize: '1.1em' }}
                            >
                                Enter Text
                            </span>
                        </div>
                        <div style={{ padding: '0 12px 12px 12px' }}>
                            <div className="form-group form-group-above confirmDialogMessage">
                                <label
                                    htmlFor="fillPrompt"
                                    className="form-label"
                                    style={{
                                        fontSize: '1.1em',
                                        marginBottom: 5
                                    }}
                                >
                                    Enter the text to fill into the text fields.
                                </label>
                                <input
                                    id="fillPrompt"
                                    type="text"
                                    value={this.state.value}
                                    onChange={event =>
                                        this.handleChange(event.target.value)
                                    }
                                    style={{ width: 332 }}
                                    autoFocus
                                />
                            </div>
                            <div>
                                <JQueryUiButton
                                    id="fill-all"
                                    disabled={false}
                                    onClick={() => this.onFillAll()}
                                    style={{ margin: 5, width: 100 }}
                                >
                                    Fill All
                                </JQueryUiButton>
                                <JQueryUiButton
                                    id="fill-visible"
                                    disabled={false}
                                    onClick={() => this.onFillVisible()}
                                    style={{ margin: 5, width: 100 }}
                                >
                                    Fill Visible
                                </JQueryUiButton>
                                <JQueryUiButton
                                    id="fill-cancel"
                                    disabled={false}
                                    onClick={() => this.onCancel()}
                                    style={{ margin: 5, width: 100 }}
                                >
                                    Cancel
                                </JQueryUiButton>
                            </div>
                        </div>
                    </div>
                </Draggable>
            </div>
        );
    }

    /**
     * Handles the input changing
     * @param value The new value
     */
    private handleChange(value: string) {
        this.setState({ value });
    }

    /**
     * Handles the "Fill All" button being clicked
     */
    private onFillAll() {
        this.props.onClose(true, this.state.value);
    }

    /**
     * Handles the "Fill Visible" button being clicked
     */
    private onFillVisible() {
        this.props.onClose(false, this.state.value);
    }

    /**
     * Handles the "Cancel" button being clicked
     */
    private onCancel() {
        this.props.onClose(false);
    }
}
